import { FC } from 'react'

import { FieldProps, FormInputProps } from 'brief-form'
import { Questionnaire } from 'commons/types/DTO/bank/quarterlyReport/questionnaire'
import { Select } from 'ui/components/Select'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { SecondText } from '../../style'

type PreviousSARFilingStatusProps = {
  Field: <Input extends React.ComponentType<FormInputProps<any, any>>>(
    props: FieldProps<Input, Questionnaire>
  ) => JSX.Element
}

export const PreviousSARFilingStatus: FC<PreviousSARFilingStatusProps> = ({ Field }) => (
  <>
    <SecondText>
      <i>Previous SAR Filing Status:</i>
    </SecondText>
    <FormRow>
      <Col>
        <Field
          name="previousSARFilingStatus"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'Limited SAR',
                value: 'limited_sar'
              },
              {
                label: 'Priority SAR',
                value: 'priority_sar'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
  </>
)
